import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import { ToastProvider } from './context/ToastContext'
import { WorryingProvider } from './context/WorryingContext'
import { LoadingProvider } from './context/LoadingContext'

// Windows-style hashes (#\path) do not match HashRouter routes — normalize to #/path.
;(() => {
  const { hash } = window.location
  if (hash && hash.includes('\\')) {
    const fixed = `#${hash.slice(1).replace(/\\/g, '/')}`
    if (fixed !== hash) {
      window.location.replace(`${window.location.pathname}${window.location.search}${fixed}`)
    }
  }
})()

const root = createRoot(document.getElementById('root'))
root.render(
  <WorryingProvider>
    <LoadingProvider>
      <ToastProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>
        </Provider>
      </ToastProvider>
    </LoadingProvider>
  </WorryingProvider>,
)

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
